module.exports = __webpack_public_path__ + "static/media/classes.e818a41c.svg";